import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [

    {
        path: '/dashboard', title: 'Dashboard', icon: 'ft-airplay', class: '', roleType: ['SuperAdmin , Customer, Recurring, Once-Off,BothCategoryg,_Admin,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [],
    },
    // {
    //     path: '/wifidetails', title: 'WiFi Details', icon: 'ft-users', class: '',
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },
    {
        path: '', title: 'WiFi Details', icon: 'ft-wifi', class: 'has-sub', roleType: ['Customer, Recurring, Once-Off,BothCategoryg,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/wifidetails', title: 'WiFi Details', icon: '', class: '', roleType: ['Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
                badge: '', badgeClass: '', isExternalLink: true,
                submenu: []
            },
            {
                path: '/updatewifidetails', title: 'Update WiFi Details', icon: '', class: '', roleType: ['Customer, Recurring, Once-Off,BothCategoryg,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
                badge: '', badgeClass: '', isExternalLink: true,
                submenu: []
            },
        ]
    },
    {
        path: '/support-ticket', title: 'Support', icon: 'ft-headphones', class: '', roleType: ['CustomerRecurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/reseller-dashboard', title: 'Dashboard', icon: 'ft-bar-chart-2', class: '', roleType: ['Reseller'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/support-ticket-admin', title: 'Support', icon: 'ft-headphones', class: '', roleType: ['SuperAdmin,_Admin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/homecoverage', title: 'Check Coverage', icon: 'ft-map-pin', class: '', roleType: ['Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    // {
    //     path: '/changeofservice', title: 'Change of Service', icon: 'ft-repeat', class: '',roleType: ['Customer, Recurring, Once-Off,BothCategory'],
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },
    {
        path: '/cancellationofservice', title: 'Cancellation of Service', icon: 'ft-wifi-off', class: '', roleType: ['Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/renewvoucher', title: 'Renew Voucher', icon: 'ft-refresh-cw', class: '', roleType: ['Once-Off,BothCategory,OnceOffActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/retrypayment', title: 'Retry Payment', icon: 'ft-rotate-ccw', class: '', roleType: ['Recurring,BothCategory,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '', title: 'Manage Payments', icon: 'ft-credit-card', class: 'has-sub', roleType: ['Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/paymenthistory', title: 'Payment History', icon: '', class: '', roleType: ['Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
                badge: '', badgeClass: '', isExternalLink: true,
                submenu: []
            },
            {
                path: '/updatecreditcard', title: 'Update Credit Card', icon: '', class: '', roleType: ['Recurring,BothCategory,RecurrActiveCustomer,BothActiveCustomer'],
                badge: '', badgeClass: '', isExternalLink: true,
                submenu: []
            }
            // {
            //     path: '/updatewifidetails', title: 'Update WiFi Details', icon: 'ft-users', class: '',
            //     badge: '', badgeClass: '', isExternalLink: true,
            //     submenu: []
            // },
        ]
    },

    {
        path: '/reseller-user-management', title: 'Manage Clients', icon: 'ft-users', class: '', roleType: ['Reseller'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },

    {
        path: '/reseller-application-management', title: 'Manage Applications', icon: 'ft-file-text', class: '', roleType: ['Reseller'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/myprofile', title: 'My Profile', icon: 'ft-user', class: '', roleType: ['Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/myprofile', title: "Dealer's Profile", icon: 'ft-user', class: '', roleType: ['Reseller'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/referfriends', title: 'Refer & Earn', icon: 'ft-users', class: '', roleType: ['Customer, Recurring, Once-Off, BothCategoryg, OnceOffActiveCustomer, RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/voucher', title: 'My Rewards', icon: 'fa fa-gift', class: '', roleType: ['OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },

    {
        path: '/redeemdetails', title: 'Redeemed Coupon', icon: 'fa fa-shopping-bag', class: '', roleType: ['OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/manageorder', title: 'Manage Order', icon: 'ft-clipboard', class: '', roleType: ['SuperAdmin,_Admin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    // {
    //     path: '/managepayouts', title: 'Manage Referrals', icon: 'ft-users', class: '', roleType: ['SuperAdmin'],
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },
    {
        path: '/manage-referral', title: 'Manage Referrals', icon: 'ft-users', class: '', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/customeramendment', title: 'Customer Amendment', icon: 'ft-user-check', class: '', roleType: ['SuperAdmin,_Admin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    // {
    //     path: '/manageadhoc', title: 'Manage Adhoc', icon: 'ft-file', class: '',roleType: ['SuperAdmin'],
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },

    // {
    //     path: '/manageadhoc', title: 'Manage Adhoc', icon: 'ft-file', class: '',roleType: ['SuperAdmin'],
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },

    {
        path: '/eftpayments', title: 'EFT Payments', icon: 'ft-file', class: '', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/salesreptable', title: 'Manage Sales Rep', icon: 'ft-user-plus', class: '', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/resaletable', title: 'Manage Reseller', icon: 'ft-anchor', class: '', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '', title: 'Notifications', icon: 'ft-bell', class: 'has-sub', roleType: ['SuperAdmin,_Admin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/managecommunication', title: 'Portal Notifications', icon: '', class: '', roleType: ['SuperAdmin,_Admin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/manageotpnotification', title: 'Manage OTP Notification ', icon: '', class: '', roleType: ['SuperAdmin,_Admin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
        ]
    },
    {
        path: '/manageuser', title: 'Manage Users', icon: 'ft-users', class: '', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },
    {
        path: '/zoompaymentdetails', title: 'Zoom Payment Details', icon: 'ft-users', class: '', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: []
    },

    // {
    //     path: '/applicationfail', title: 'fail', icon: 'ft-anchor', class: '',roleType: ['SuperAdmin'],
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },


    // {
    //     path: '/servicechange', title: 'Service Change', icon: 'fa fa-exchange', class: '',roleType: ['Customer, Recurring, Once-Off,BothCategory'],
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },
    {
        path: '', title: 'Reports', icon: 'ft-align-left', class: 'has-sub', roleType: ['_Admin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/onceoffexpiryreport', title: 'Once-Off Expiry Report', icon: '', class: '', roleType: ['_Admin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },

        ]
    },
    {
        path: '', title: 'Reports', icon: 'ft-align-left', class: 'has-sub', roleType: ['SuperAdmin'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/voucherreport', title: 'Voucher Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/commissionreport', title: 'Commission Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/customerreport', title: 'Customer Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/failedpaymentreport', title: 'Failed Payment Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/onceoffexpiryreport', title: 'Once-Off Expiry Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/paymentreport', title: 'Success Payment Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
            {
                path: '/paymentreminderreport', title: 'Payment Reminder Report', icon: '', class: '', roleType: ['SuperAdmin'],
                badge: '', badgeClass: '', isExternalLink: false,
                submenu: []
            },
        ]
    },

    {
        path: '', title: 'Invoice Generation', icon: 'ft-credit-card', class: 'has-sub', roleType: ['SuperAdmin,_Admin,Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
        badge: '', badgeClass: '', isExternalLink: false,
        submenu: [
            {
                path: '/invoicereport', title: 'Invoice Report', icon: '', class: '', roleType: ['SuperAdmin,_Admin,Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
                badge: '', badgeClass: '', isExternalLink: true,
                submenu: []
            },
            {
                path: '/invoicestatement', title: 'Invoice Statement', icon: '', class: '', roleType: ['SuperAdmin,_Admin,Customer, Recurring, Once-Off,BothCategory,OnceOffActiveCustomer,RecurrActiveCustomer,BothActiveCustomer'],
                badge: '', badgeClass: '', isExternalLink: true,
                submenu: []
            }
        ]
    },


    // {
    //     path: '/content-layout', title: 'Content Layout', icon: 'ft-square', class: '',
    //     badge: '', badgeClass: '', isExternalLink: false,
    //     submenu: []
    // },
    // {
    //     path: '', title: 'Menu Levels', icon: 'ft-align-left', class: 'has-sub',
    //     badge: '1', badgeClass: 'badge badge-pill badge-danger float-right mr-1 mt-1', isExternalLink: false,
    //     submenu: [
    //         {
    //             path: 'javascript:;', title: 'Second Level', icon: '', class: '',
    //             badge: '', badgeClass: '', isExternalLink: true,
    //             submenu: []
    //         },
    //         {
    //             path: '', title: 'Second Level Child', icon: '', class: 'has-sub',
    //             badge: '', badgeClass: '', isExternalLink: false,
    //             submenu: [
    //                 {
    //                     path: 'javascript:;', title: 'Third Level 1.1', icon: '', class: '',
    //                     badge: '', badgeClass: '', isExternalLink: true,
    //                     submenu: []
    //                 },
    //                 {
    //                     path: 'javascript:;', title: 'Third Level 1.2', icon: '', class: '',
    //                     badge: '', badgeClass: '', isExternalLink: true,
    //                     submenu: []
    //                 },
    //             ]
    //         },
    //     ]
    // },
    // {
    //     path: '/changelog', title: 'ChangeLog', icon: 'ft-file', class: '',
    //     badge: '', badgeClass: '', isExternalLink: false, submenu: []
    // },
    // {
    //     path: 'https://pixinvent.com/apex-angular-4-bootstrap-admin-template/documentation',
    //     title: 'Documentation', icon: 'ft-folder', class: '',
    //     badge: '', badgeClass: '', isExternalLink: true, submenu: []
    // },
    // {
    //     path: 'https://pixinvent.ticksy.com/', title: 'Support', icon: 'ft-life-buoy', class: '',
    //     badge: '', badgeClass: '', isExternalLink: true, submenu: []
    // }
];

